import { render, staticRenderFns } from "./WatchNowModal.vue?vue&type=template&id=0805a9d8"
import script from "./WatchNowModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchNowModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports